export enum MathOperationType {
    Addition = 0,
    Multiply = 1,
}